import type { AgentSharedFileResult } from '@cdf/api-client-react';
import { Link } from 'react-router-dom';

/** Render only the server-qualified native outcome, never model-supplied save claims. */
export function SharedAgentFileResult({ result }: { result: AgentSharedFileResult }) {
  return <div role="status" aria-label="Original file result" className="space-y-1 rounded-md border p-3 text-sm">
    {result.state === 'saved' ? <p>Saved <Link className="font-medium underline" to={result.link}>{result.filename}</Link>.</p>
      : <><p>Save unconfirmed: {result.filename}.</p><p>Check the original request before another write. No file is saved again by checking.</p></>}
  </div>;
}
